import React from 'react';

import classes from './ReadOnlyTooltipContent.module.scss';

export const ReadOnlyTooltipContent = () => {
    return (
        <div className={classes.ReadOnlyTooltipContent}>
            <div className={classes.title}>Read-only view</div>
            <div>
                This view is read-only and was created by another user.
                <br />
                Clone this view to make changes or create row configurations.
            </div>
        </div>
    );
};
